/* eslint quote-props: ["error", "consistent"] */
const profile = {
  "Change your avatar": "Change your avatar",
  "Cancel": "Cancel",
};

export default profile;
